"use client";

import { c as _c } from "react/compiler-runtime";
import { Space } from "antd";
import { ProfileSection } from "./(home)/ProfileSection/ProfileSection";
import { ContactSection } from "./(home)/ContactSection/ContactSection";
import { RoleSection } from "./(home)/RoleSection/RoleSection";
import { SkillSection } from "./(home)/SkillSection/SkillSection";
import { ExperienceSection } from "./(home)/ExperienceSection/ExperienceSection";
import styles from "./page.module.sass";
export default function HomePage(_props) {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "100%"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <main className={styles.main} data-sentry-component="HomePage" data-sentry-source-file="page.tsx"><Space orientation="vertical" size={48} style={t0} data-sentry-element="Space" data-sentry-source-file="page.tsx"><ProfileSection data-sentry-element="ProfileSection" data-sentry-source-file="page.tsx" /><RoleSection data-sentry-element="RoleSection" data-sentry-source-file="page.tsx" /><ContactSection data-sentry-element="ContactSection" data-sentry-source-file="page.tsx" /><SkillSection data-sentry-element="SkillSection" data-sentry-source-file="page.tsx" /><ExperienceSection data-sentry-element="ExperienceSection" data-sentry-source-file="page.tsx" /></Space></main>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}